import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PartnerDocumentModule} from './modules/document/partner-document.module';
import {PartnerNoteModule} from './modules/note/partner-note.module';
import {PartnerPersonModule} from './modules/person/partner-person.module';
import {errorMessages} from '../core/error/errorMessages';
import {PartnerContactModule} from './modules/contact/partnerContact.module';
import {PartnerRepository} from './common/impl/service/ngrx/partner.repository';
import {PartnerDataService} from './common/impl/service/ngrx/partnerData.service';

@NgModule({
    providers: [
    ],
    imports: [
        PartnerDocumentModule,
        PartnerNoteModule,
        PartnerPersonModule,
        PartnerContactModule,
    ]
})
export class PartnerModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                partnerService: PartnerRepository,
                partnerDataService: PartnerDataService,
    ) {

        entityDataService.registerServices({
            Partner: partnerDataService,
        });

        entityServices.registerEntityCollectionServices({
            Partner: partnerService,
        });

        errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà un patient');
    }
}

export const PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE = 'PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE';
